






















































































































































import { defineComponent, onMounted } from '@vue/composition-api';
import SearchPane from '@/components/SettouMessageBoard/components/SearchPane/index.vue';
import BoardEntryRow from '@/components/SettouMessageBoard/components/BoardEntryRow.vue';
import BoardEntryEditModal from '@/components/SettouMessageBoard/components/BoardEntryEditModal/index.vue';
import PhotoModal from '@/components/lib/PhotoModal/index.vue';
import NotificationArea from '@/components/lib/NotificationArea/index.vue';
import { useBoardCore } from '@/components/SettouMessageBoard/composables/useBoardCore';
import useBoardDisplayControl from '@/components/SettouMessageBoard/composables/useBoardDisplayControl';
import { useBoardTabPager } from '@/components/SettouMessageBoard/composables/useBoardTabPager';
import { useBoardEntryCrud } from '@/components/SettouMessageBoard/composables/useBoardEntryCrud';
import { useBoardEntryPermissions } from '@/components/SettouMessageBoard/composables/useBoardEntryPermissions';
import { useBoardCsvExport } from '@/components/SettouMessageBoard/composables/useBoardCsvExport';
import { usePhotoModal } from '@/components/SettouMessageBoard/composables/usePhotoModal';

export default defineComponent({
  components: {
    SearchPane,
    BoardEntryRow,
    PhotoModal,
    BoardEntryEditModal,
    NotificationArea,
  },
  setup() {
    const {
      state,
      isSuperAdmin,
      paginatedBoardEntries,
      onChangeBoardTab,
      dtFormat,
      searchBoardEntries,
    } = useBoardCore();
    const {
      currentBoardTab,
      isHonbuBoard,
      isMaintenanceBoard,
      canUseHonbuReportSearchConditions,
      boardTabDepartmentDisp,
      isCreatableRole,
      isRepliableRole,
    } = useBoardDisplayControl();
    const {
      refTabBar,
      filteredBoardTabs,
      beforeFilteredBoardTabs,
      afterFilteredBoardTabs,
      isNextDisabled,
      onClickTabListItem,
      prevClick,
      nextClick,
    } = useBoardTabPager();
    const {
      shouldShowEditModal,
      shouldShowDeleteModal,
      createBoardEntry,
      editBoardEntry,
      addBoardEntry,
      updateBoardEntry,
      cancelEditBoardEntry,
      tryDeleteBoardEntry,
      deleteBoardEntry,
    } = useBoardEntryCrud();
    const { isEditable, isDeletable, canCreateBoardEntry } = useBoardEntryPermissions();
    const { downloadCSV } = useBoardCsvExport();
    const { photoModalState, showPhotoModal, hidePhotoModal } = usePhotoModal();

    // PC→SP→PCと切り替えた時、resize時点ではまだ本コンポーネントが描画されておらず
    // 破棄済みの旧タブバー(幅0)でタブ最大表示数が計算されるため、描画後に再計算する
    onMounted(() => state.tab.onResizeFunc());

    return {
      state,
      isSuperAdmin,
      paginatedBoardEntries,
      onChangeBoardTab,
      dtFormat,
      searchBoardEntries,
      currentBoardTab,
      isHonbuBoard,
      isMaintenanceBoard,
      canUseHonbuReportSearchConditions,
      boardTabDepartmentDisp,
      isCreatableRole,
      isRepliableRole,
      refTabBar,
      filteredBoardTabs,
      beforeFilteredBoardTabs,
      afterFilteredBoardTabs,
      isNextDisabled,
      onClickTabListItem,
      prevClick,
      nextClick,
      shouldShowEditModal,
      shouldShowDeleteModal,
      createBoardEntry,
      editBoardEntry,
      addBoardEntry,
      updateBoardEntry,
      cancelEditBoardEntry,
      tryDeleteBoardEntry,
      deleteBoardEntry,
      isEditable,
      isDeletable,
      canCreateBoardEntry,
      downloadCSV,
      photoModalState,
      showPhotoModal,
      hidePhotoModal,
    };
  },
});
